import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.main');
import { OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.main/view.scss */
:host {
  display: block;
  height: 100vh;
  background: #f5f7fa;
}

.app-shell {
  width: 100%;
  height: 100%;
  display: flex;
  background: linear-gradient(180deg, rgba(248, 250, 252, 0.98) 0%, rgba(241, 245, 249, 0.96) 100%);
}

.app-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: #f6f8fb;
}

.app-scroll {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.app-loading {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.24);
  backdrop-filter: blur(8px);
}

.loading-card {
  min-width: 180px;
  padding: 22px 24px;
  border-radius: 16px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.16);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: #334155;
  font-size: 13px;
  font-weight: 700;
}`],
})
export class LayoutMainComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  public ref: ChangeDetectorRef,@Inject( Router)  public router: Router) { }

    public async ngOnInit() {
        await this.service.init(this);
        if (!this.service.auth.session || !this.service.auth.session.id) {
            location.href = '/access';
            return;
        }
    }
}

export default LayoutMainComponent;